import { runtimeConfig, hasRuntimeConfig } from '../runtime';

/**
 * THE ONE function that turns a stored asset key into a playable/renderable
 * URL. Everything downstream — the device manifest, the candidate cards, the
 * player — stores KEYS and calls this.
 *
 * Today that is a string concat against the public media host: the blob
 * container is publicAccess:'Blob' with listing off (main.bicep), the same
 * public-read bet S3 made, so media needs no signing. When a container SAS
 * lands (shared/media_store.py records the same deferral), this function is
 * the only thing that changes. Store URLs in the manifest instead and every
 * offline pack has dead URLs baked into it.
 */
export function mediaUrl(key: string | null | undefined): string | null {
  if (!key) return null;
  // Already absolute (the API mints some URLs itself, e.g. playback-urls).
  if (/^https?:\/\//i.test(key)) return key;
  // Only before boot. mediaDomain itself is a required config key now, so
  // there is no "configured but absent" case left to guard against.
  if (!hasRuntimeConfig()) return null;
  return `${runtimeConfig().mediaDomain}/${String(key).replace(/^\/+/, '')}`;
}

/** Documented convention from shared/starters.py. */
export function starterPortraitKey(slug: string): string {
  return `catalog/${slug}/portrait.png`;
}

/** Documented convention from the clip seed manifest (clips/<assetId>/...). */
export function clipKey(assetId: string): string {
  return `clips/${assetId}/master.mp4`;
}

export function clipPosterKey(assetId: string): string {
  return `clips/${assetId}/poster.jpg`;
}
